export function parseQueryString(queryString) {
	const result = {};
	const start = queryString.substring(0, 1) === '?' ? 1 : 0;
	const components = queryString.substring(start).split('&');
	for (const component of components) {
		const [key, val] = component.split('=');
		result[key] = decodeURIComponent(val);
	}
	return result;
}
